import { Modal } from '@components';
import { AttributesFeed } from './AtributesFeed';

import { AttributesFeedModalProps } from './AttributesFeedModal.props';

/**
 * AttributesFeedModal component
 * @returns {JSX.Element}
 */

export const AttributesFeedModal = ({
  businessUnit,
  businessUnitId,
  isModalOpen,
  onSuccess,
  onClose,
}: AttributesFeedModalProps): JSX.Element => {
  return (
    <Modal open={!!isModalOpen} padding="0" onClose={onClose}>
      <AttributesFeed
        businessUnit={businessUnitId}
        uniqueIdKey={businessUnit?.uniqueIdKey}
        onClose={onClose}
        onSuccess={onSuccess}
      />
    </Modal>
  );
};

AttributesFeedModal.displayName = 'AttributesFeedModal';
